import React from 'react';
import { Link } from 'react-router-dom';
import { getCuisineImageUrl } from '../utils/imageUtils';

const CuisineCard = ({ cuisine, onClick }) => {
    const imageName = cuisine.name.replace(/\s+/g, '-');
    const cuisineImageUrl = getCuisineImageUrl(imageName);

    // If onClick is provided, use it instead of Link
    if (onClick) {
        return (
            <div 
                onClick={() => onClick(cuisine)}
                className="diet-card"
                style={{ cursor: 'pointer' }}
            >
                <img 
                    className="diet-card-image"
                    src={cuisineImageUrl} 
                    alt={cuisine.name} 
                />
                <div className="diet-card-content">
                    <h3 className="recipe-filter-name">{cuisine.name}</h3>
                </div>
            </div>
        );
    }

    return (
        <Link 
            to={`/cuisine/${cuisine.name}`} 
            state={{ cuisine: cuisine }}
            className="diet-card"
        >
            <img 
                className="diet-card-image"
                src={cuisineImageUrl} 
                alt={cuisine.name} 
            />
            <div className="diet-card-content">
                <h3 className="recipe-filter-name">{cuisine.name}</h3>
            </div>
        </Link>
    );
};

export default CuisineCard;